<template>
    <html>
    <head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
        <meta name="mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <link rel="icon" type="image/png" href="favicon.png" />
        <title>Restó APP</title>
    </head>

    <body class="home-page">
        <div class="col-lg-8 mx-auto p-3 py-md-5">
            <main>
                <h3>Datos de Reserva</h3>
                <hr class="" />

                <form v-on:submit.prevent="modificarReserva">

                    <div class="text-center">
                        <label class="form-label">Ordenante: {{ nombre }}</label>
                    </div>
                    <div class="text-center">
                        <label class="form-label">{{ cantidad_mayor }} Mayores</label>
                    </div>
                    <div class="text-center">
                        <label class="form-label">{{ cantidad_menor }} Menores</label>
                    </div>
                    <div class="text-center">
                        <label class="form-label fecha-puntos">{{ fecha }} </label>
                    </div>
                    <div class="text-center">
                        <label class="form-label">{{ horario }} </label>
                    </div>
                <br>

                <button type="button" class="mb-3 btn btn-danger  btn-lg"  
    :disabled='isDisabledCancelar'
    style=" color: white;  font-size: 20px; font-weight: bold;" v-on:click="cancelarReserva">
        Rechazar Reserva
    </button>

                <button 
    :disabled='isDisabledConfirmar'
    type="button" class="mb-3 btn btn-success btn-lg " v-on:click="confirmarReserva" style="margin-left: 20px;color: white; font-size: 20px; font-weight: bold;">
        Confirmar Reserva
    </button>
   
                    

                    <div v-if="confirmacionCliente" class="message-container">
                        <p class="text message-format">{{ confirmacionCliente }}</p>
                    </div>


                </form>
                <PopUp :show="success" @close="success = false">
                    <template #body>
                        <p>{{ success_msg }}</p>
                    </template>
                </PopUp>
                <PopUp :show="error" @close="error = false">
                    <template #body>
                        <p>{{ error_msg }}</p>
                    </template>
                </PopUp>

                <PopUpConfirmacionHtml :show="confirmacion_html" @close="confirmacion_html = false" @confirmar="confirmar();confirmacion_html = false;">
  <template #body>
    <div v-html="confirmacion_msg_html" style="white-space: pre-line;"></div>
  </template>
</PopUpConfirmacionHtml>

<PopUpConfirmacionHtml :show="confirmacionCancelar_html" @close="confirmacionCancelar_html = false" @confirmar="cancelar();confirmacionCancelar_html = false;">
  <template #body >
    <div v-html="confirmacion_cancelacion_msg_html" style="white-space: pre-line;"></div>
  </template>
</PopUpConfirmacionHtml>


      <PopUpConfirmacion :show="confirmacion" @close="confirmacion = false" @confirmar="confirmar();confirmacion = false;">
  <template #body>
    <p>{{ confirmacion_msg }}</p>
  </template>
</PopUpConfirmacion>

<PopUpConfirmacion :show="confirmacionCancelar" @close="confirmacionCancelar = false" @confirmar="cancelar();confirmacionCancelar = false;">
  <template #body>
    <p>{{ confirmacion_msg }}</p>
  </template>
</PopUpConfirmacion>

                <Footer />
            </main>
        </div>
    </body>
    </html>
</template>

<script>
import axios from "axios";
import PopUp from "../components/PopUp.vue";
import PopUpConfirmacion from "../components/PopUpConfirmacion.vue";
import PopUpConfirmacionHtml from "../components/PopUpConfirmacionHtml.vue";


import Footer from "../components/Footer.vue";
import "vue2-datepicker/index.css";

export default {
    name: "VerReservaConfirmacion",
    components: { Footer, PopUp,PopUpConfirmacion,PopUpConfirmacionHtml},
    data: function () {
        return {
            restaurante: Object,

            direccion: "",
            usuarioNoRegistrado: Object,
            nombre: "",
            reserva_id: "",
            resto_id: "",
            apellido: "",
            email: "",
            telefono: "",
            horario: "",
            horarios: [],
            fecha: "",
            cantidad_mayor: "",
            cantidad_menor: "",
            estado: "",
            menores: [],
            error: false,
            success: false,
            error_msg: "",
            success_msg: "",
            isDisabledConfirmar:false,
            isDisabledCancelar:false,
            confirmacion:false,
            confirmacion_msg:"",
            confirmacionCancelar:false,
            confirmacionCliente: "",
            rechazoCliente: "",
            confirmacion_msg_html:"",
            confirmacion_html:false,
            confirmacion_cancelacion_msg_html:"",
            confirmacionCancelar_html:false,

        };
    },
    methods: {
        
        cancelar(){
            if (this.estado == "Cancelada") {
                this.error = true;
                this.error_msg = "La reserva ya ha sido cancelada!";
                return;
            }
            let json = {
                id: this.reserva_id,
                email: this.mail,
                placeId: this.resto_id,
                reserva_id: this.reserva_id,
            };
            axios
                .post("/cancelar_reserva_manual", json)
                .then((data) => {
                    if (data.status != 200) {
                        this.error = true;
                        this.error_msg =
                            "No se pudo cancelar la reserva. Vuelva a intentar mas tarde";
                    } else {
                        this.success = true;
                        this.isDisabledCancelar=true;
                        this.isDisabledConfirmar=true;
                        this.success_msg = "Reserva cancelada con exito. ";
                    }
                });
        },
        cancelarReserva() {
            this.confirmacion_cancelacion_msg_html=`<h5>Desea rechazar la reserva?</h5>`+
            
            ` <div> 
                            Establecimiento ${this.restaurante.nombre}:
                            Enviaremos al Cliente ${this.nombre} el siguiente mail de rechazo del pedido de reserva:
                    
                            Estimada/o ${this.nombre},
                            
                            El restaurante "${this.restaurante.nombre}" nos informa que lamentablemente no tiene plazas disponibles para tu pedido de reserva:

                            Ordenante:  ${this.nombre}
                            ${this.cantidad_mayor} Mayores
                            ${this.cantidad_menor} Menores
                            ${this.fecha} a las ${this.horario}

                            Te sugerimos que hagas otra búsqueda en nuestra App.

                            Cordiales saludos
                            
                            Atención al cliente
                            Resto UP
                            </div>
                        `;
            this.confirmacionCancelar_html=true;
},


confirmar(){
            if (this.estado == "Reservada") {
                this.error = true;
                this.error_msg = "La reserva ya ha sido confirmada!";
                return;
            }
            let json = {
                id: this.reserva_id,
                email: this.mail,
                placeId: this.resto_id,
                reserva_id: this.reserva_id,
            };
            axios
                .post("/confirmar_reserva_manual", json)
                .then((data) => {
                    if (data.status != 200) {
                        this.error = true;
                        this.error_msg =
                            "No se pudo cancelar la reserva. Vuelva a intentar mas tarde";
                    } else {
                        this.success = true;
                        this.success_msg = "Reserva confirmada con exito. ";
                        this.isDisabledCancelar=true;
                        this.isDisabledConfirmar=true;
                    }
                });
        },
        confirmarReserva() {

            this.confirmacion_msg_html=`<h5>Desea confirmar la reserva?</h5>`+
            
            `
                            Establecimiento ${this.restaurante.nombre}:
                            Enviaremos al Cliente ${this.nombre} el siguiente mail de confirmación de reserva:

                            Estimado/a Sr./Sra. ${this.nombre}, 

                            El restaurante "${this.restaurante.nombre}" nos informa que ha confirmado tu pedido:
                            
                            Ordenante:  ${this.nombre}
                            ${this.cantidad_mayor} Mayores
                            ${this.cantidad_menor} Menores
                            ${this.fecha}
                            ${this.horario}

                            Con el siguiente número de reserva: Nº ${this.reserva_id}

                            Lo esperamos en ${this.direccion}

                            Cordiales saludos

                            Atención al cliente
                            Resto UP

                            Nota: en caso de no poder asistir, podrá cancelar la reserva desde la app de Resto UP
                        `;
            this.confirmacion_html=true;

},


    },
    beforeMount() {
        const token = new URLSearchParams(window.location.search).get('token')
     

        if(token!=null && token!=""){
            axios.get("/getReservaToken/" + token).then((data) => {
                console.log("data",data)
            if (data.status == 200) {
                this.resto_id = data.data.restauranteGoogleId
                this.reserva_id = data.data.id
                if (data.data.estado.toLowerCase() == "Cancelada".toLowerCase() 
                || data.data.estado.toLowerCase()=="NO ACEPTADA".toLowerCase()
                || data.data.estado.toLowerCase()=="SIN DISPONIBILIDAD".toLowerCase()) {
                    this.error = true;
                    this.error_msg = "La reserva ya ha sido cancelada!";
                }
                this.estado = data.data.estado;
                if(data.data.usuarioNoRegistrado!=null){
                this.usuarioNoRegistrado = data.data.usuarioNoRegistrado;
                this.nombre = data.data.usuarioNoRegistrado.nombre;
                this.apellido = data.data.usuarioNoRegistrado.apellido;
                this.email = data.data.usuarioNoRegistrado.email;
                this.telefono = data.data.usuarioNoRegistrado.telefono;
                }else{
                    this.nombre=data.data.usuario.nombre
                    this.apellido=data.data.usuario.apellido
                    this.email=data.data.usuario.mail
                    this.telefono=data.data.usuario.telefono
                }
                if(this.estado.toLowerCase()=="Vigente".toLowerCase()){
                    this.isDisabledCancelar=true;
                    this.isDisabledConfirmar=true;
                }else if(this.estado.toLowerCase()=="Cancelada".toLowerCase() 
                ||  data.data.estado.toLowerCase()=="NO ACEPTADA".toLowerCase()
                ||  data.data.estado.toLowerCase()=="SIN DISPONIBILIDAD".toLowerCase()){
                    this.isDisabledCancelar=true;
                    this.isDisabledConfirmar=true;
                }
                this.fecha=data.data.fecha;
                this.horario=data.data.horario + ":"+ data.data.minutos.padStart(2, "0"); 
                this.cantidad_mayor = data.data.comensales_mayores;
                this.cantidad_menor = data.data.comensales_menores;
                axios
                    .get("/restaurante-google/" + this.resto_id)
                    .then((data) => {
                        if (data.status == 200) {
                            this.restaurante.nombre=data.data.id.name;
                            this.direccion=data.data.id.formattedAddress;
                        } else {
                            this.error = true;
                            this.error_msg =
                                "No se ha podido cargar la informacion del restaurante";
                        }
                    });
            } else {
                this.error = true;
                this.error_msg = "No se ha podido cargar la reserva";
            }
        });

        }
       

       
    },
};
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

:root {
    --main-color: #0047b3;
    --second-color: #0198f3;
    --grey-color: #f5f8fa;
    --border-radius-1: 9px;
    --border-radius-2: 6px;
}

body {
    font-family: "Inter", sans-serif;
    color: #083744;
    font-size: 14px;
    height: 100%;
}

.message-container {
    text-align: center;
}

.message-format {
    text-align: left;
    display: inline-block;
    white-space: pre-line;
}

.fecha-puntos {
            border-bottom: 1px dotted;
            display: inline-block;
        }

.form-group {
    text-align: left;
    margin-left: 15px;
}

.form-label {
    display: inline-block;
    min-width: 90px;
}

.form-text {
    display: inline;
}



</style>
